import React, { useEffect } from "react";
import styled from "styled-components";
import { refreshHeaderOptionToken } from "../../../utils/apis/api-header-option";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { apiURL_provider } from "../../../constants";
import { alertMessage } from "../../../services/alertService";
import { AddPhotoContainer, AddPhotoText } from "../../../styles/components";

// Styled Components
const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const LoadingDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProductImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 8px;
  margin-right: 16px;
  margin-top: 8px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  border: 1px solid #e39435;
  &:hover {
    border: 2px solid #e39435;
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

const ImageLabel = styled.label`
  cursor: pointer;
`;

interface Iprops {
  titleEN?: string;
  titleCN?: string;
  data: any[];
  noOfImage: number;
  callback: Function;
  isRequired?: boolean;
  is320?: boolean;
  maxNumber: any;
  productId: any;
}

const apiBaseURL_provider = apiURL_provider;

export default function CustomImageUpload(props: Iprops) {
  const [images, setImages] = React.useState(props.data);
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  const [loading, setLoading] = React.useState(false);


  useEffect(() => {
    if (props.data.length < props.noOfImage) {
      let dif = props.noOfImage - props.data.length;
      for (let i = 0; i < dif; i++) {
        props.data.push({
          id: 0,
          productId: props.productId,
          photoName: "",
          photoPath: "",
          isDelete: false,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeImage1 = (e: any) => {
    if (e.target.files.length) {
      setLoading(true);
  
      const allowedExtensions =
        /(\.jpg|\.jpeg|\.png|\.gif|\.xls|\.xlsx|\.doc|\.docx|\.pdf)$/i;
      const maxFileSize = 5 * 1024 * 1024; // 5 MB max
  
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
  
        // Validate type
        if (!allowedExtensions.exec(file.name)) {
          alertMessage("Error!", "Invalid file type");
          setLoading(false);
          continue;
        }
  
        // Validate size
        if (file.size > maxFileSize) {
          alertMessage("Error!", "File exceeds maximum size of 5 MB");
          setLoading(false);
          continue;
        }
  
        // TODO: Malware scan placeholder
        // You can call your backend API or library here to scan 'file' for malware before uploading
        // Example: await scanFileForMalware(file);
  
        // Proceed with upload
        prepareUpload(file.name, file, images[selectedImageIndex].id);
      }
    }
  };
  

  const getBase64 = (file: any) => {
    return new Promise((resolve) => {
      let reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const prepareUpload = (fileName: string, file: any, id: number) => {
    getBase64(file)
      .then((result) => {
        file["base64"] = result;
        let temp = file.base64.split(",");
        uploadFile(fileName, temp[1], id);
      })
      .catch((err) => {
        alertMessage(
          "Error!",
          "Converting Base 64 of " + fileName + " was failed."
        );
        setLoading(false);
      });
  };

  const uploadFile = async (fileName: string, document: string, id: number) => {
    let headers = refreshHeaderOptionToken();
    let url = "serviceprovider/FileUpload";
    let fileParam = {
      fileName: fileName,
      document: document,
    };

    axios
      .post(`${apiBaseURL_provider}/${url}`, fileParam, headers.optionPlane)
      .then(({ data }) => {
        try {
          let imgs = images;
          let index = imgs.findIndex((img: any) => img.id === id);
          if (index > -1) {
            imgs[index].photoName = data.fileName;
            imgs[index].photoPath = data.filePath;
            setImages(imgs);
            props.callback({ type: "success", data: imgs });
          }
          setLoading(false);
        } catch {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error?.response?.status && error?.response?.status === 401) {
          props.callback({ type: "401", data: [] });
        } else {
          alertMessage("Error!", "Uploading " + fileName + " was failed.");
        }
      });
  };

  return (
    <>
      {loading && (
        <LoadingContainer>
          <LoadingDiv>
            <CircularProgress color="success" />
          </LoadingDiv>
        </LoadingContainer>
      )}
      {images &&
        images.length > 0 &&
        images.map((image: any, index: number) => (
          <React.Fragment key={index}>
            <ImageLabel htmlFor="upload-button1">
              {image.photoPath === "" ? (
                <AddPhotoContainer onClick={() => setSelectedImageIndex(index)}>
                  <AddPhotoText>+ Add photo</AddPhotoText>
                </AddPhotoContainer>
              ) : (
                <ProductImage
                  src={image.photoPath}
                  alt="Product"
                  onClick={() => setSelectedImageIndex(index)}
                />
              )}
            </ImageLabel>

            <HiddenInput
              type="file"
              id="upload-button1"
              onChange={handleChangeImage1}
            />
          </React.Fragment>
        ))}
    </>
  );
}
